import React, { useState } from 'react'
import Alert from '@material-ui/lab/Alert'
import Button from '@material-ui/core/Button'
import makeStyles from '@material-ui/core/styles/makeStyles'
import RefreshIcon from '@material-ui/icons/Refresh'
import HelpIcon from '@material-ui/icons/Help'
import { VERSION_MISMATCH_ALERT_BANNER_HEIGHT } from '../../../Constants'
import VersionMismatchHelpModal from './VersionMismatchHelpModal'

const useStyles = makeStyles(
    (theme) => ({
        alertBanner: {
            height: `${VERSION_MISMATCH_ALERT_BANNER_HEIGHT}px`,
            width: '100vw',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: theme.zIndex.appBar + 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        alert: {
            backgroundColor: '#e34f4f !important',
            color: '#ffffff !important',
            width: '100%',
            height: '100%',
            borderRadius: '0 !important',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: theme.spacing(0, 3),
            '& .MuiAlert-icon': {
                color: '#ffffff',
                fontSize: '20px',
            },
            '& .MuiAlert-message': {
                display: 'flex',
                alignItems: 'center',
                flex: 1,
                justifyContent: 'center',
                padding: 0,
            },
            '& .MuiAlert-action': {
                padding: 0,
                marginRight: 0,
            },
        },
        messageContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
        },
        alertText: {
            fontSize: '14px',
            fontWeight: 500,
            color: '#ffffff',
            flex: 1,
            textAlign: 'left',
        },
        buttonContainer: {
            display: 'flex',
            gap: theme.spacing(1),
            alignItems: 'center',
        },
        alertButton: {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            color: '#ffffff',
            border: '1px solid rgba(255, 255, 255, 0.5)',
            fontSize: '12px',
            fontWeight: 500,
            padding: theme.spacing(0.5, 1.5),
            minWidth: 'auto',
            height: '32px',
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.3)',
            },
            '& .MuiButton-startIcon': {
                marginRight: theme.spacing(0.5),
                '& svg': {
                    fontSize: '16px',
                },
            },
        },
    }),
    { name: 'VersionMismatchAlert' }
)

const VersionMismatchAlert = ({version}) => {
    const classes = useStyles()
    const [helpModalOpen, setHelpModalOpen] = useState(false)

    const handleReload = () => {
        if ('caches' in window) {
            caches.keys().then(names => {
                names.forEach(name => {
                    caches.delete(name)
                })
            }).finally(() => {
                window.location.reload()
            })
        } else {
            window.location.href = window.location.href.split('?')[0] + '?nocache=' + new Date().getTime()
        }
    }

   
    const handleHelp = () => {
        setHelpModalOpen(true)
    }

    const handleCloseHelpModal = () => {
        setHelpModalOpen(false)
    }

    return (
        <>
            <div className={classes.alertBanner}>
                <Alert 
                    severity="error" 
                    className={classes.alert}
                    action={null}
                >
                    <div className={classes.messageContainer}>
                        <div className={classes.alertText}>
                            A new version of the application (v{version}) is available. Please <b>Reload</b> to update or click <b>Help</b> for manual steps.
                        </div>
                        <div className={classes.buttonContainer}>
                            <Button
                                variant="outlined"
                                size="small"
                                className={classes.alertButton}
                                startIcon={<RefreshIcon />}
                                onClick={handleReload}
                            >
                                Reload
                            </Button>
                            <Button
                                variant="outlined"
                                size="small"
                                className={classes.alertButton}
                                startIcon={<HelpIcon />}
                                onClick={handleHelp}
                            >
                                Help
                            </Button>
                        </div>
                    </div>
                </Alert>
            </div>

            <VersionMismatchHelpModal 
                open={helpModalOpen} 
                onClose={handleCloseHelpModal} 
            />
        </>
    )
}

export default VersionMismatchAlert